import { render, staticRenderFns } from "./Ch.vue?vue&type=template&id=055e2682&scoped=true"
import script from "./Ch.vue?vue&type=script&lang=js"
export * from "./Ch.vue?vue&type=script&lang=js"
import style0 from "./Ch.vue?vue&type=style&index=0&id=055e2682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055e2682",
  null
  
)

export default component.exports